import React from "react";
import Header from "../components/Header";
import HeroSearch from "../components/HeroSearch";
import { BrandsSection, DestinationsSection, OffersSection, RewardsSection, TestimonialsSection } from "../components/Sections";
import PublicHotels from "../components/PublicHotels";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <div className="min-h-screen bg-white text-neutral-900">
      <Header />
      <main>
        <HeroSearch />
        <PublicHotels />
        <BrandsSection />
        <DestinationsSection />
        <OffersSection />
        <RewardsSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
